
export const testimonials = [
  {
    name: "Client Name",
    desc: "CEO and founder of Project name",
    img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreie2jpirxhuiqm3isaf7mhu2pagnkyf2lsbbs2eil3vxjatxwz2eki',
    video:
      "https://res.cloudinary.com/dmjw7pe6k/video/upload/v1745324172/SCKN_Testimonal_hreunc.mp4",
  },
  {
    name: "VEIKO",
    desc: "CEO and founder of Binarge",
    img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreidsjgb44parva5nemsoozrstc3ijujdffhrveyxpgghe6z5x2w6bi',
    video:
      "https://res.cloudinary.com/dmjw7pe6k/video/upload/v1745324494/Binarge_Testimonal_Final_dv48t1.mp4",
  },
  {
    name: "SHANE",
    desc: "CEO and founder of Fidex",
    img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreidxc3mexmx753oz5hltf4eeqwopxregpsn5pz4litx6vvciw72rxm',
    video:
      "https://res.cloudinary.com/dmjw7pe6k/video/upload/v1745324392/FIEDX_FINAL_OUTPUT_1_it47eg.mp4",
  },
];

export const sidebarItems = [
  { key: "crypto-exchange", label: "Centralized Exchange" },
  { key: "ico", label: "ICO" },
  { key: "crypto-wallet", label: "Crypto Wallet" },
  { key: "mobile-app", label: "Mobile App" },
  { key: "rwa", label: "RWA" },
  { key: "bot", label: "Trading Bot" },
  { key: "carbon-marketplace", label: "Carbon Marketplace" },
  { key: "educational-platform", label: "Educational Platform" },
  { key: "meme-coin", label: "Meme Coin", id: "scrollname1" },
  { key: "generative-ai", label: "Generative AI" },
  { key: "p2p", label: "P2P" },
  { key: "wallet", label: "Wallet", id: "scrollname1" },
  { key: "gaming", label: "Gaming" },
  { key: "own-blockchain", label: "Own Blockchain" },
  {
    key: "dex",
    label: "Decentralized Exchange & Defi",
  },
  { key: "stock-exchange", label: "Stock Exchange" },
  { key: "online-prediction", label: "Online Prediction" },
  { key: "on-demand", label: "On Demand" },
  { key: "forex", label: "Forex" },
  { key: "crypto-payment", label: "Crypto Payment" },

  { key: "mlm", label: "MLM" },
  { key: "nft", label: "NFT" },
  { key: "metaverse", label: "Metaverse" },
];

export const tabContent = {
  "crypto-exchange": [
    // {
    //   img: require("../assets/capitalexc_thumbnail.webp"),
    //   alt: "CaptialEXC",
    //   title: "CaptialEXC",
    //   hoverClass: "normal_capitalexc",
    // },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreicx5rvo7gk6icz6bx6uop547crfa7o76yrquwdcs5g3eyb72jqs34',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762610556/CapitalEXC_t6iupd.mp4",
      alt: "CaptialEXC",
      title: "CaptialEXC",
      hoverClass: "normal_capitalexc",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreifqfqckod5yfuq6e3zkr3lzitnp5ryzmtvdmmtxg2q4ntubgnvosu',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762621371/crymadx_gif_za9g4m.mp4",
      alt: "Crymadx",
      title: "Crymadx",
      hoverClass: "normal_imagecrymadx",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreifmu5bzrq25ultcztfwa25a5iv3hklvyayc3hztsbenicz4g5xfmi',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762621549/groww_park_gif_cp1elc.mp4",
      alt: "Groww Park",
      title: "Groww Park",
      hoverClass: "normal_gp",
    },

    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreihptt5eprqnp4mql5qzwpkl66k7ubpl4tolbgc74pannqbxqwi3vi',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762621854/nexus_pro_sh5igf.mp4",
      alt: "Nexus Pro",
      title: "Nexus Pro",
      hoverClass: "normal_nexus",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreia7shrzn2b7toyb7xmqjgwnwpwpto4rdrqwnvfkgyxu5rwdfiwhze',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762622016/sellcrypt_apiyxo.mp4",
      alt: "Sellcrypt",
      title: "Sellcrypt",
      hoverClass: "normal_sellcrypt",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreidpyprkxqws67wdmji3kr7weqnq6b2maxlkkfvrinray3z2d5hy7q',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762623022/pitiklini_web_thaqg5.mp4",
      alt: "Pitiklini",
      title: "Pitiklini",
      hoverClass: "normal_imagepitiklini_web",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreicwah24myvewyuzqybr7snx443oxnaxg6wpew4vz7v35f7vp4v3ly',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762622441/otc_gif_so6onc.mp4",
      alt: "OTC",
      title: "OTC",
      hoverClass: "normal_otc",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreiakxmgxebrwivg5o7356w3aysjkpbi2nb4gn2dnbj5loomijch2lq',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762622505/fidexweb_gif_wvvkfw.mp4",
      alt: "Fidex",
      title: "Fidex",
      hoverClass: "normal_imageticicryex",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreihzxv3xudug3suhhgihrkwfqbjtjtq2brbtmvcuzqv6aiug4z7djy',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762622557/VOltrixExchangegif_pqd5kk.mp4",
      alt: "Voltrix Crypt",
      title: "Voltrix Crypt",
      hoverClass: "normal_imageticicryone",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreie27xpo3m4gitg4yksmve6p5usgztmokzw4pwqbscylnlebshcvzq',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762622600/BitBuyerxgif_xaija8.mp4",
      alt: "Bit Buyrex",
      title: "Bit Buyrex",
      hoverClass: "normal_imageticicrybit",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreifma6643wwsk5hq3qrxyhb37iivpgulrapinj3r436lse2gkabie4',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762622636/taikonz_gif_knz4px.mp4",
      alt: "Taikonz",
      title: "Taikonz",
      hoverClass: "normal_taikonz",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreidczbhunoyt24svwy3dj354cq5sajmca3d66mhranbywd6izd2mjy',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762622718/cashbit_quae6o.mp4",
      alt: "Cashbit",
      title: "Cashbit",
      hoverClass: "normal_cashbit",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreicyd4d25it7hojcts6nessyrqeg22yvep6ze2hy5whtq24caoxfm4',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762622768/kryptonza_xdhh7r.mp4",
      alt: "Kryptonza",
      title: "Kryptonza",
      hoverClass: "normal_kryptonza",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreidjjscpg5me2gvjdh5sbznj3doen67faahkw3oveddiyblqaebm3a',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762622817/adverb_nl68od.mp4",
      alt: "Adverb",
      title: "Adverb",
      hoverClass: "normal_adverb",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreieaqdwzpubswp7b4dvdunnmpcqexeq2stq3th5k3wefdk4h2ry7ma',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762622873/smartbull_dobmbk.mp4",
      alt: "Smartbull",
      title: "Smartbull",
      hoverClass: "normal_smartbull",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreib55hc357664fbleretn7hvxptbsvtvayqk7jk3v7onn2akkw5xya',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762622916/netex_wjxl6d.mp4",
      alt: "Net1ex",
      title: "Net1ex",
      hoverClass: "normal_netex",
    },
  ],
  ico: [
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreibcjx6ysqratczi6wi4oypl4s5l6q7oggytquzljwpohre5dnrosi',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762751258/Aussivonew_rgpcvu.mp4",
      alt: "Crypzion",
      title: "Crypzion",
      hoverClass: "normal_imageAussivo",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreie7f4il5tmareulxlm4mbmnuewbsiq3oy65iq77lhb5f6ajibdzge',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762751300/ZurumiICOgif_vba0il.mp4",
      alt: "Zurumi",
      title: "Zurumi",
      hoverClass: "normal_imageticicotwo",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreif3mgjydspolouxb2pnfq6c7hd3by6oomz4gco7rd7u6abvayivcq',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762751337/VOltrixICOgif_lloadu.mp4",
      alt: "Voltrix",
      title: "Voltrix",
      hoverClass: "normal_imageticicothree",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreie4kg6ymmvhq36w7flafcmhhyqa3aq3bqzywpdfk7icp3ysotn4hq',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762751361/meroneum_vjthig.mp4",
      alt: "Meroneum",
      title: "Meroneum",
      hoverClass: "normal_meroneum",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreigd4dveh4olwzsbd2644t4ltrct7kesagv4mqcxm3jyslwqxbrn7m',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762751384/edufex_l0oxia.mp4",
      alt: "Edufex",
      title: "Edufex",
      hoverClass: "normal_edufex",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreig3w7xyuknbfj5igcru6bxjwlavpf6w3jnxmlxt5s7we7cokk7gki',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762751411/solalgo_gif_eg49db.mp4",
      alt: "Solalgo",
      title: "Solalgo",
      hoverClass: "normal_imagesolalgo",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreie5bk6sj6ziyfntdnw64w4ya7phib6jhb4hxzh5lacvelmn7qn7gy',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762751432/arbitrex_rsxage.mp4",
      alt: "Arbitrex",
      title: "Arbitrex",
      hoverClass: "normal_arbitrex",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreihgh7w7a3pmc4d4fdcnwkyhx7xqqluhftperxmtm52e7aqf4mrjrm',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762751452/Chola_mgd4qk.mp4",
      alt: "Chola",
      title: "Chola",
      hoverClass: "normal_chola",
    },
  ],
  "crypto-wallet": [
    {
      img: 'https://res.cloudinary.com/dr3lpkvua/image/upload/v1789648596/swapiumEXCThumbnail_oj5jqe.webp',
      gif: "https://res.cloudinary.com/dr3lpkvua/video/upload/v1789648656/swapiumEXC_bpy9sx.mp4",
      alt: "swapiumEXC",
      title: "swapiumEXC",
      hoverClass: "normal_swapiumExc",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreic2weytgzlm6kjzsytxxraqn4bb2342anjw4ohtemwsgiitakslou',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762756796/custodial_wallet_jrjih7.mp4",
      alt: "Vault Pulse - Custodial Wallet",
      title: "Vault Pulse - Custodial Wallet",
      hoverClass: "normal_custodial_wallet",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreif4gndnvwfpmu4jaewnn7zkf77padwakzo6wlivvuz72vcoo33qte',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762756910/pixerpay_heb2ob.mp4",
      alt: "Pixer Pay - Non Custodial Wallet",
      title: "Pixer Pay - Non Custodial Wallet",
      hoverClass: "normal_pixerpay",
    },
     {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreie6kzvtycqrblqqi5amedhw76xpbmsp3m7q24kheapghtejsq7uga',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762757057/frax_yssyjw.mp4",
      alt: "Frax",
      title: "Frax",
      hoverClass: "normal_imagefrax",
    },
  ],
  "mobile-app": [
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreifsdwso6bkde3kj2dx7k6gcszydu2uat6jsd3u3nrjgdtn4f5orde',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762757014/crymadx_mobile_gif_rlcswf.mp4",
      alt: "Crymadx",
      title: "Crymadx",
      hoverClass: "normal_crymadx_mobile",
    },
    {
      img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1745403511/Crydible_uzdixc.png",
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762758098/normal_crydible_adewfp.mp4",
      alt: "Crydible",
      title: "Crydible",
      hoverClass: "normal_crydible",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreieigv3lf7kno3s27b6d5mng5z7z4bou4wd2n7zomlfkuef5bockli',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762757976/pitiklinie_mobile_yj6y7j.mp4",
      alt: "Pitiklini",
      title: "Pitiklini",
      hoverClass: "normal_imagepitklini",
    },
    {
      img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1745674630/Dream_11_Clone_gv6e2y.png",
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762758237/normal_fantasy_kgrwvi.mp4",
      alt: "Fantasy Sport",
      title: "Fantasy Sport",
      hoverClass: "normal_fantasy",
    },
    {
      img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1745403521/Scene_nvndll.png",
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762758275/normal_altz_bot_g2hjlu.mp4",
      alt: "Altranz Bot",
      title: "Altranz Bot",
      hoverClass: "normal_altz_bot",
    },
    {
      img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1745403511/phonepe_k7rw3l.png",
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762758315/normal_phonepe_clone_ad2hva.mp4",
      alt: "Phonepe Clone",
      title: "Phonepe Clone",
      hoverClass: "normal_phonepe_clone",
    },
    {
      img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1745403511/Health_Crare_vwnxmy.png",
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762758366/normal_healthcare_awi7rn.mp4",
      alt: "Healthcare",
      title: "Healthcare",
      hoverClass: "normal_healthcare",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreielyn3bfumouk5txxgiv5qel2kvwxmq2sgiup6h5zydpqyttuhjau',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762757117/VoltrixAppgif_ymfp0s.mp4",
      alt: "Voltrix Crypt",
      title: "Voltrix Crypt",
      hoverClass: "normal_imageticicrytwo",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreidqq7vuavzjwbrkt5qy5fmehhex2qrmjqie654cfplwcaqxxgs4hu',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762757181/telemini_x5cfjg.mp4",
      alt: "Tele Mini Game",
      title: "Tele Mini Game",
      hoverClass: "normal_imageticiapp",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreidk4z4khuxcffx3em72ot5ur6fiwuodqw3ah35ndmzohws2xukxja',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762757260/Bitgetappgif_ljh8sb.mp4",
      alt: "Nexus Pro",
      title: "Nexus Pro",
      hoverClass: "normal_imageticiappone",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreihy7fphkpq33glghb72fcith5jbkqpjbcrtcwww2x7hpel45b2oae',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762758409/normal_imagerifa_t52u1t.mp4",
      alt: "Rifa World",
      title: "Rifa World",
      hoverClass: "normal_imagerifa",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreid76qfky7tx2g4j67fvxg4ttmotmlarg4uhn575zntrhklvvwqn6m',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762757325/TrustPeappgif_a7zor7.mp4",
      alt: "Trust Pe",
      title: "Trust Pe",
      hoverClass: "normal_imageticiapptwo",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreiaord3jilenwzc2i3gbnh6sxwt5qkwb4tlquj2ou3bxfuixwd7jrq',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762757369/FidexAppgif_bs2dl8.mp4",
      alt: "Fidex",
      title: "Fidex",
      hoverClass: "normal_imageticiappthre",
    },
  ],
  bot: [
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreiffr7giu3h2mwjkt3mpurj3siuyvr7j3kkdu743laqltmo3kkwhia',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762760368/binarge_gif_pobtdq.mp4",
      alt: "Binarge",
      title: "Binarge",
      hoverClass: "normal_binarge",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreidcspnuahb6eur2irq4kfyswx3epbesrslwpq2mqrjmzjz2gemoli',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762760381/WyScalegif_xyfyoc.mp4",
      alt: "Wy Scale",
      title: "Wy Scale",
      hoverClass: "normal_imageticcmbot",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreibs62dxyc2mfb6rjpwd7ztjsp45ltptdpgkmpiamqwt66gg2xzwvi',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762760393/MevBotTngif_xueysn.mp4",
      alt: "MEV Bot",
      title: "MEV Bot",
      hoverClass: "normal_imageticmvbot",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreiedsvjyv4iezfcfuheu24ebjqmyc3td5w7k24n3kphpoqmdiclzx4',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762760409/skgbot_h6lhyw.mp4",
      alt: "SKG Bot",
      title: "SKG Bot",
      hoverClass: "normal_imageskg",
    },

    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreidki7aufwvr57l6su7i2pxuewpzvu3hcwulblxggozvd6w2speela',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762760421/Enzogif_qsa8pv.mp4",
      alt: "Enzo",
      title: "Enzo",
      hoverClass: "normal_imageticbotone",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreic6brfvuo3zqvqff5qantmwvcrdxjbwmw6ugttkoh2deozjjmus5i',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762760435/DaulahBot_xmm3y5.mp4",
      alt: "Daulah Holdings",
      title: "Daulah Holdings",
      hoverClass: "normal_imageticbottwo",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreicugxuou6tzap2evbyxuthu6foywor4546plrl7vaek3ryalh56ju',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762760448/flashGif_jw5vs3.mp4",
      alt: "Flash Loan Bot",
      title: "Flash Loan Bot",
      hoverClass: "normal_imageticbotthre",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreif6pvdt3p4wcknvj3rdouecmn7fifgk6ckj6wsrkidiyhmla5nhdi',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762760458/marketMakingBotgif_gkxn4y.mp4",
      alt: "Market Making Bot",
      title: "Market Making Bot",
      hoverClass: "normal_imageticbotfour",
    },
  ],
  "carbon-marketplace": [
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreidujwboyxsyxasqw6h7du7jou5b7kdgr2kqtdsfpwlts32kl5lvqq',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762760875/lorien-gif_ki4p86.mp4",
      alt: "Lorien",
      title: "Lorien",
      hoverClass: "normal_imagelorien",
    },
  ],
  "educational-platform": [
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreia7n2rc4vs65k7zzegjndfmm52lg2f6jx4ucdnysralnlvdjeik5y',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762761213/Terryverse_gif_twahv2.mp4",
      alt: "Terryverse",
      title: "Terryverse",
      hoverClass: "normal_imageterryverse",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreiazgmniqzkstdldcpgtr7sfgvu5co2jstdtgbxeuhvdkyphost2lm',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762761655/ISDL_1_cdkczg.mp4",
      alt: "ISDL",
      title: "ISDL",
      hoverClass: "normal_isdl",
    },
  ],
  gaming: [
    {
      img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1745403513/Casino_p0yguu.png",
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762761902/normal_alt_casino_xbbexv.mp4",
      alt: "Altranium Casino",
      title: "Altranium Casino",
      hoverClass: "normal_alt_casino",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreihyzoq2wq3ye2iidoc4xbupzebucisjztofn2i2grmcr7uuqbumpe',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762761964/HupBetTNgif_b3vetf.mp4",
      alt: "Hop Bet",
      title: "Hop Bet",
      hoverClass: "normal_imagethubbet",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreiemiyfohcf6zdkj6ejwt6yrlb3flb2wv22avhk33l2mgecw6jjy7e',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762762014/IC.gamegif_cj0cml.mp4",
      alt: "IC.Game",
      title: "IC.Game",
      hoverClass: "normal_imageticgame",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreiap6i7x3miesh3vl6klr7nnnfkqrz3amha3wc5qlj5iululgaqspi',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762762062/lott3_yblnd3.mp4",
      alt: "Lott 3",
      title: "Lott 3",
      hoverClass: "normal_lott3",
    },
  ],
  "own-blockchain": [
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreia4a5olfmit6ghr3ha7ven3gp5nq7cie22qrrsx723h5ib6i6nvxq',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762762259/altranium_blockchain_awuqjp.mp4",
      alt: "Altranium Blockchain",
      title: "Altranium Blockchain",
      hoverClass: "normal_alt_blkchain",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreici72qtvj5mer4dz5gamnwa2btmxzi5y2lyptdytkas37fmgjv3xm',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762762274/ownblockchainGif_vmgrxr.mp4",
      alt: "Maalscan",
      title: "Maalscan",
      hoverClass: "normal_imageticiblockcha",
    },
  ],
  dex: [
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreihr7wdbzofsx4jk4c3mzgn7zli6n2amuuurt32gbaeo56ia3hmeye',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762762439/keedexgif_ta481t.mp4",
      alt: "KeeDx",
      title: "KeeDx",
      hoverClass: "normal_imageticidefione",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreifxbve4qcfrnop4nagpbgotd7raz5appiem3ss5vgc7lxqhdnzxne',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762762463/yarloogif_m1urbz.mp4",
      alt: "Yarloo",
      title: "Yarloo",
      hoverClass: "normal_imageticidefitwo",
    },
  ],
  "stock-exchange": [
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreiejui7is2vx7hu52odpkiqlzvbgnqa7unmhn3owc6mxea5q2dhi6a',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762762596/zerodha_clone_ooh06d.mp4",
      alt: "Zerodha Clone",
      title: "Zerodha Clone",
      hoverClass: "normal_zero_clone",
    },
  ],
  "online-prediction": [
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreihzwt2x2fiq2zkqggcxmy2fazgn6bvhbcvs4m4nf2ngdvw5wb3vtu',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762762730/proboclone_ob0e4w.mp4",
      alt: "Probo Clone",
      title: "Probo Clone",
      hoverClass: "normal_pb_clone",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreih3rf745fkz7jagmi52klya7nfxcs7zfbbx5sy7s4cwmkuaxkrxi4',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762762713/normal_plymarket_clone_l3fshb.mp4",
      alt: "Polymarket Clone",
      title: "Polymarket Clone",
      hoverClass: "normal_plymarket_clone",
    },
  ],
  "meme-coin": [
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreievuzco5gvjxmvdjumx2domcseutu36noydzcknizgyb7fgz3l33i',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762763562/AntiIsraelWar_irczal.mp4",
      alt: "Anti Israel War",
      title: "Anti Israel War",
      hoverClass: "normal_imageant",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreigdcaiu6r6nxhgaff3j5kow6cjlwpkf4kefwa63w3f2zi2qrd3vhy',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762763570/BabyWalrusgif_trluff.mp4",
      alt: "Baby Walrus",
      title: "Baby Walrus",
      hoverClass: "normal_imageticicoone",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreighxk7z7qu7zgjoiynqygwgtsorlmmxc5nr7hqm6i5grezvhxkkmm',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762763581/sckngif_y64paf.mp4",
      alt: "Screaming Chicken",
      title: "Screaming Chicken",
      hoverClass: "normal_imagesckn",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafybeibomc45lwumdeo2jq4jfb27kiw5bfygwryb2ittbm4asnerlbdnti',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762763595/Mitcome_ifwph8.mp4",
      alt: "Mitcome",
      title: "Mitcome",
      hoverClass: "normal_imagemonk",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreiepcvrdxeazyeecyy4azs2pzhg7ngxswdw2yw35iklj3c6whaqsvq',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762763606/rexitngif_lqtgka.mp4",
      alt: "Roksy",
      title: "Roksy",
      hoverClass: "normal_imagerexi",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreicgoyp6xicujnkrsvrg4my2aq6kxo3ydutzqkvwqarkmkqqqhjsbe',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762763616/tttngif_nicfqw.mp4",
      alt: "TTT",
      title: "TTT",
      hoverClass: "normal_imagetttn",
    },
  ],
  "generative-ai": [
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreidi6hvelg5zctzm7engquimti4mmxkatu6ysacesx2hamhcmbysdu',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762764008/genai_nwasu9.mp4",
      alt: "Generative AI",
      title: "Generative AI",
      hoverClass: "normal_genai",
    },
  ],
  p2p: [
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreibndljs5juejgchhrj55zvd2yj2yxrhe26rl5aqu5e4tlz3f3pwqq',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762764109/cryptosellbuy_gamuyo.mp4",
      alt: "Crypto Sell Buy - P2P",
      title: "Crypto Sell Buy - P2P",
      hoverClass: "normal_P2P",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreiaheryvjkt3iwy6qtr3t2x2oy7ffs2vs3yzlte65uz3hiasw52mpy',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762764287/lynxbit_v4aevl.mp4",
      alt: "LYNXBIT",
      title: "LYNXBIT",
      hoverClass: "normal_lynxbit",
    },
  ],
  wallet: [
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreic2weytgzlm6kjzsytxxraqn4bb2342anjw4ohtemwsgiitakslou',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762756796/custodial_wallet_jrjih7.mp4",
      alt: "Custodial Wallet",
      title: "Custodial Wallet",
      hoverClass: "normal_custodial_wallet",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreif4gndnvwfpmu4jaewnn7zkf77padwakzo6wlivvuz72vcoo33qte',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762756910/pixerpay_heb2ob.mp4",
      alt: "Non Custodial Wallet",
      title: "Non Custodial Wallet",
      hoverClass: "normal_pixerpay",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreie6kzvtycqrblqqi5amedhw76xpbmsp3m7q24kheapghtejsq7uga',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762757057/frax_yssyjw.mp4",
      alt: "Frax",
      title: "Frax",
      hoverClass: "normal_imagefrax",
    },
  ],
  "on-demand": [
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreibglwqq5xqequk6455vfdza5qn6gfhkyp3valxfw2oqfgk2hjhjkm',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762764642/flixer_bopd6g.mp4",
      alt: "Netflix Clone",
      title: "Netflix Clone",
      hoverClass: "normal_flixer",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreich2jol7ibsusbn5btlof6uogcdyfrtc2vng5iy7n6scj2hw5rl4a',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762764589/normal_datingapp_pnjag4.mp4",
      alt: "Dating App",
      title: "Dating App",
      hoverClass: "normal_datingapp",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreid32dywiupuvptldw62oyku5ybjr45m5tkvxrf7bg5ape3r5sogay',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762765044/amazon_clone_ruwn7k.mp4",
      alt: "Amazon Clone",
      title: "Amazon Clone",
      hoverClass: "normal_amazon_clone",
    },
    {
      img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1745403511/phonepe_k7rw3l.png",
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762758315/normal_phonepe_clone_ad2hva.mp4",
      alt: "Phonepe Clone",
      title: "Phonepe Clone",
      hoverClass: "normal_phonepe_clone",
    },
    {
      img: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1745403511/Health_Crare_vwnxmy.png",
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762758366/normal_healthcare_awi7rn.mp4",
      alt: "On Demand Healthcare",
      title: "On Demand Healthcare",
      hoverClass: "normal_healthcare",
    },
  ],
  forex: [
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreig2a2lmbfvdcz2k4ifl4qxqa2zmb47orqxx7jy2kxoeojp4i37iyy',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762765148/forextrading_dgjrgi.mp4",
      alt: "Forex Trading",
      title: "Forex Trading",
      hoverClass: "normal_frx_trading",
    },
  ],
  "crypto-payment": [
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreiaqeubgdqiryfub7pr2nmzrluhvb3tob56cassvxsuf7imnfcqdbe',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762765244/paymentgif_xa9ai3.mp4",
      alt: "Cryto Payment",
      title: "Cryto Payment",
      hoverClass: "normal_imageticinftpay",
    },
  ],
  rwa: [
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreid4uob7bb73pghzf7qpwh35enuepr3mfltorckevrjoydwb2iqdqy',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762759694/assetly_fadz14.mp4",
      alt: "Assetly",
      title: "Assetly",
      hoverClass: "normal_assetly",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreidjcx2h63nm54ifgizz6scdkovf6ohxqraz55lyvwh6roimq3i3qa',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762759702/aarka_qn0v9p.mp4",
      alt: "RWA",
      title: "Aarka",
      hoverClass: "normal_rwa",
    },
    {
      img: 'https://res.cloudinary.com/dr3lpkvua/image/upload/v1789639365/SBX_Thumbnail_hxv4ns.webp',
      gif: "https://res.cloudinary.com/dr3lpkvua/video/upload/v1789639398/sbx_i5ilp3.mp4",
      alt: "SuperBlock",
      title: "SuperBlock",
      hoverClass: "normal_sbx",
    },
  ],
  mlm: [
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreifppcug3plnivzfsjp2pb5zy4tzv3v33a4gaao6zfjw37s3jjqf4i',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762765696/WXDLgif_vnkln4.mp4",
      alt: "WXDL",
      title: "WXDL",
      hoverClass: "normal_imageticmlm",
    },
  ],
  nft: [
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreielrjdwmwtvf7o5ihevnnq5etp5dx26bhzfb3dq45hfgso6rke7km',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762765709/nftgif3_yq6xqk.mp4",
      alt: "Fantically",
      title: "Fantically",
      hoverClass: "normal_imageticinfttwo",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreiebxoywk3jvf7ktdz7gr2657zemwcnauhd37vxigi5szzhqv6dnae',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762765722/loudgit_qmqzzm.mp4",
      alt: "Loud",
      title: "Loud",
      hoverClass: "normal_imageticinftthree",
    },
    {
      img: 'https://brown-imperial-puffin-988.mypinata.cloud/ipfs/bafkreibcv3tp654xx3qh6j63run336wtjiimz6c7rbsk5txvlayojs5wbu',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762765734/nftgif_mfhlc4.mp4",
      alt: "NFT",
      title: "NFT",
      hoverClass: "normal_imageticinft",
    },
  ],
  metaverse: [
    {
      img: 'https://res.cloudinary.com/dqtdd1frp/image/upload/v1781271610/thumbnail_mf0gzn.webp',
      gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1781271620/26339aae-2d33-4869-b057-7b9b47e28243_gppgi7.mp4",
      alt: "Metaverse",
      title: "Metaverse",
      hoverClass: "normal_imageticinftmeta",
    },
  ],
};

export const gifItems = [
 {
    className: "normal_imageant",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762763562/AntiIsraelWar_irczal.mp4",
  },
  {
    className: "normal_imagesckn",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762763581/sckngif_y64paf.mp4",
  },
  {
    className: "normal_imagerexi",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762763606/rexitngif_lqtgka.mp4",
  },
  {
    className: "normal_imagetttn",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762763616/tttngif_nicfqw.mp4",
  },
  {
    className: "normal_imagethubbet",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762761964/HupBetTNgif_b3vetf.mp4",
  },
  {
    className: "normal_imageticgame",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762762014/IC.gamegif_cj0cml.mp4",
  },
  {
    className: "normal_imageticmlm",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762765696/WXDLgif_vnkln4.mp4",
  },
  {
    className: "normal_imageticcmbot",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762760381/WyScalegif_xyfyoc.mp4",
  },
  {
    className: "normal_imageticmvbot",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762760393/MevBotTngif_xueysn.mp4",
  },
  {
    className: "normal_imagefrax",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762757057/frax_yssyjw.mp4",
  },
  {
    className: "normal_imageAussivo",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762751258/Aussivonew_rgpcvu.mp4",
  },
  {
    className: "normal_imageticicoone",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762763570/BabyWalrusgif_trluff.mp4",
  },
  {
    className: "normal_imageticicotwo",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762751300/ZurumiICOgif_vba0il.mp4",
  },
  {
    className: "normal_imageticicothree",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762751337/VOltrixICOgif_lloadu.mp4",
  },
  {
    className: "normal_imageticicryex",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762622505/fidexweb_gif_wvvkfw.mp4",
  },
  {
    className: "normal_imageticicryone",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762622557/VOltrixExchangegif_pqd5kk.mp4",
  },
  {
    className: "normal_imageticicrytwo",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762757117/VoltrixAppgif_ymfp0s.mp4",
  },
  {
    className: "normal_imageticiapp",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762757181/telemini_x5cfjg.mp4",
  },
  {
    className: "normal_imageticiappone",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762757260/Bitgetappgif_ljh8sb.mp4",
  },
  {
    className: "normal_imageticiapptwo",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762757325/TrustPeappgif_a7zor7.mp4",
  },
  {
    className: "normal_imageticiappthre",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762757369/FidexAppgif_bs2dl8.mp4",
  },
  {
    className: "normal_imagemonk",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762763595/Mitcome_ifwph8.mp4",
  },
  {
    className: "normal_imageticicrybit",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762622600/BitBuyerxgif_xaija8.mp4",
  },
  {
    className: "normal_imageticbotone",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762760421/Enzogif_qsa8pv.mp4",
  },
  {
    className: "normal_imageticbottwo",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762760435/DaulahBot_xmm3y5.mp4",
  },
  {
    className: "normal_imageticbotthre",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762760448/flashGif_jw5vs3.mp4",
  },
  {
    className: "normal_imageticbotfour",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762760458/marketMakingBotgif_gkxn4y.mp4",
  },
  {
    className: "normal_imageticiblockcha",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762762274/ownblockchainGif_vmgrxr.mp4",
  },
  {
    className: "normal_imageticidefione",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762762439/keedexgif_ta481t.mp4",
  },
  {
    className: "normal_imageticidefitwo",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762762463/yarloogif_m1urbz.mp4",
  },
  {
    className: "normal_imageticinft",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762765734/nftgif_mfhlc4.mp4",
  },
  {
    className: "normal_imageticinftone",
    gif: "https://blue-electrical-python-561.mypinata.cloud/ipfs/bafybeif3hzoti4ildhx6kxhzotgkzrryk2cmt6ovmxblbnnumznc52il4e",
  },
  {
    className: "normal_imageticinfttwo",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762765709/nftgif3_yq6xqk.mp4",
  },
  {
    className: "normal_imageticinftmeta",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1781271620/26339aae-2d33-4869-b057-7b9b47e28243_gppgi7.mp4",
  },
  {
    className: "normal_imageticinftthree",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762765722/loudgit_qmqzzm.mp4",
  },
  {
    className: "normal_imageticinftpay",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762765244/paymentgif_xa9ai3.mp4",
  },
  {
    className: "normal_gp",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762621549/groww_park_gif_cp1elc.mp4",
  },
  {
    className: "normal_pb_clone",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762762730/proboclone_ob0e4w.mp4",
  },
  {
    className: "normal_altz_bot",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762758275/normal_altz_bot_g2hjlu.mp4",
  },
  {
    className: "normal_rwa",
    // gif: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1745400411/RWA_fqinba.gif",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762759702/aarka_qn0v9p.mp4",
  },
  {
    className: "normal_sbx",
    gif: "https://res.cloudinary.com/dr3lpkvua/video/upload/v1789639398/sbx_i5ilp3.mp4",
  },
  {
    className: "normal_otc",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762622441/otc_gif_so6onc.mp4",
  },
  {
    className: "normal_zero_clone",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762762596/zerodha_clone_ooh06d.mp4",
  },
  {
    className: "normal_alt_casino",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762761902/normal_alt_casino_xbbexv.mp4 ",
  },
  {
    className: "normal_plymarket_clone",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762762713/normal_plymarket_clone_l3fshb.mp4",
  },
  {
    className: "normal_phonepe_clone",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762758315/normal_phonepe_clone_ad2hva.mp4",
  },
  {
    className: "normal_crydible",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762758098/normal_crydible_adewfp.mp4 ",
  },
  {
    className: "normal_fantasy",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762758237/normal_fantasy_kgrwvi.mp4",
  },
  {
    className: "normal_healthcare",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762758366/normal_healthcare_awi7rn.mp4",
  },
  {
    className: "normal_binarge",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762760368/binarge_gif_pobtdq.mp4",
  },
  {
    className: "normal_frx_trading",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762765148/forextrading_dgjrgi.mp4",
  },
  {
    className: "normal_datingapp",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762764589/normal_datingapp_pnjag4.mp4",
  },
  {
    className: "normal_amazon_clone",
    // gif: "https://res.cloudinary.com/dmjw7pe6k/image/upload/v1745400362/Amazon_Clone_demo_ttymfk.gif",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762765044/amazon_clone_ruwn7k.mp4",
  },
  {
    className: "normal_alt_blkchain",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762762259/altranium_blockchain_awuqjp.mp4",
  },
  {
    className: "normal_P2P",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762764109/cryptosellbuy_gamuyo.mp4",
  },
  {
    className: "normal_nexus",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762621854/nexus_pro_sh5igf.mp4",
  },
  {
    className: "normal_sellcrypt",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762622016/sellcrypt_apiyxo.mp4",
  },
  {
    className: "normal_imagepitiklini_web",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762623022/pitiklini_web_thaqg5.mp4",
  },
  {
    className: "normal_imagepitklini",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762757976/pitiklinie_mobile_yj6y7j.mp4",
  },
  {
    className: "normal_imagerifa",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762758409/normal_imagerifa_t52u1t.mp4",
  },
  {
    className: "normal_imagesolalgo",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762751411/solalgo_gif_eg49db.mp4",
  },
  {
    className: "normal_imageskg",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762760409/skgbot_h6lhyw.mp4",
  },
  {
    className: "normal_imagecrymadx",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762621371/crymadx_gif_za9g4m.mp4",
  },
  {
    className: "normal_imagelorien",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762760875/lorien-gif_ki4p86.mp4",
  },
  {
    className: "normal_imageterryverse",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762761213/Terryverse_gif_twahv2.mp4",
  },
  {
    className: "normal_crymadx_mobile",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762757014/crymadx_mobile_gif_rlcswf.mp4",
  },
  {
    className: "normal_capitalexc",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762610556/CapitalEXC_t6iupd.mp4",
  },
  {
    className: "normal_flixer",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762764642/flixer_bopd6g.mp4",
  },
  {
    className: "normal_assetly",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762759694/assetly_fadz14.mp4",
  },
  {
    className: "normal_meroneum",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762751361/meroneum_vjthig.mp4",
  },
  {
    className: "normal_edufex",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762751384/edufex_l0oxia.mp4",
  },
  {
    className: "normal_lynxbit",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762764287/lynxbit_v4aevl.mp4",
  },
  {
    className: "normal_genai",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762764008/genai_nwasu9.mp4",
  },
  {
    className: "normal_lott3",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762762062/lott3_yblnd3.mp4",
  },
  {
    className: "normal_isdl",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762761655/ISDL_1_cdkczg.mp4",
  },
  {
    className: "normal_taikonz",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762622636/taikonz_gif_knz4px.mp4",
  },
  {
    className: "normal_arbitrex",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762751432/arbitrex_rsxage.mp4",
  },
  {
    className: "normal_chola",
    gif:"https://res.cloudinary.com/dqtdd1frp/video/upload/v1762751452/Chola_mgd4qk.mp4",
  },
  {
    className: "normal_cashbit",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762622718/cashbit_quae6o.mp4",
  },
  {
    className: "normal_kryptonza",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762622768/kryptonza_xdhh7r.mp4",
  },
  {
    className: "normal_adverb",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762622817/adverb_nl68od.mp4",
  },
  {
    className: "normal_smartbull",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762622873/smartbull_dobmbk.mp4",
  },
  {
    className: "normal_netex",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762622916/netex_wjxl6d.mp4",
  },
  {
    className: "normal_pixerpay",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762756910/pixerpay_heb2ob.mp4",
  },
  {
    className: "normal_custodial_wallet",
    gif: "https://res.cloudinary.com/dqtdd1frp/video/upload/v1762756796/custodial_wallet_jrjih7.mp4",
  },
  {
    className: "normal_swapiumExc",
    gif: "https://res.cloudinary.com/dr3lpkvua/video/upload/v1789648656/swapiumEXC_bpy9sx.mp4",
  },
];
